/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardScheduleStatus } from './RewardScheduleStatus';
import {
    RewardScheduleStatusFromJSON,
    RewardScheduleStatusFromJSONTyped,
    RewardScheduleStatusToJSON,
} from './RewardScheduleStatus';
import type { S2WGame } from './S2WGame';
import {
    S2WGameFromJSON,
    S2WGameFromJSONTyped,
    S2WGameToJSON,
} from './S2WGame';
import type { RewardTypeSummary } from './RewardTypeSummary';
import {
    RewardTypeSummaryFromJSON,
    RewardTypeSummaryFromJSONTyped,
    RewardTypeSummaryToJSON,
} from './RewardTypeSummary';

/**
 * A prize schedule with the S2W game it belongs to. GDS returns the schedule summary; back-office-service attaches
 * the game.
 * @export
 * @interface RewardScheduleWithGame
 */
export interface RewardScheduleWithGame {
    /**
     * 
     * @type {string}
     * @memberof RewardScheduleWithGame
     */
    rulesLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RewardScheduleWithGame
     */
    supportLink?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RewardScheduleWithGame
     */
    promoText: Array<string>;
    /**
     * 
     * @type {Array<RewardTypeSummary>}
     * @memberof RewardScheduleWithGame
     */
    rewards: Array<RewardTypeSummary>;
    /**
     * 
     * @type {Date}
     * @memberof RewardScheduleWithGame
     */
    endDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof RewardScheduleWithGame
     */
    startDate: Date;
    /**
     * 
     * @type {RewardScheduleStatus}
     * @memberof RewardScheduleWithGame
     */
    status: RewardScheduleStatus;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RewardScheduleWithGame
     */
    s2wGameId: string;
    /**
     * 
     * @type {string}
     * @memberof RewardScheduleWithGame
     */
    name: string;
    /**
     * A UUID in its canonical hyphenated form, in either letter case.
     * @type {string}
     * @memberof RewardScheduleWithGame
     */
    id: string;
    /**
     * 
     * @type {S2WGame}
     * @memberof RewardScheduleWithGame
     */
    game: S2WGame;
}



/**
 * Check if a given object implements the RewardScheduleWithGame interface.
 */
export function instanceOfRewardScheduleWithGame(value: object): value is RewardScheduleWithGame {
    if (!('promoText' in value) || value['promoText'] === undefined) return false;
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('startDate' in value) || value['startDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('s2wGameId' in value) || value['s2wGameId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('game' in value) || value['game'] === undefined) return false;
    return true;
}

export function RewardScheduleWithGameFromJSON(json: any): RewardScheduleWithGame {
    return RewardScheduleWithGameFromJSONTyped(json, false);
}

export function RewardScheduleWithGameFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardScheduleWithGame {
    if (json == null) {
        return json;
    }
    return {
        
        'rulesLink': json['rulesLink'] == null ? undefined : json['rulesLink'],
        'supportLink': json['supportLink'] == null ? undefined : json['supportLink'],
        'promoText': json['promoText'],
        'rewards': ((json['rewards'] as Array<any>).map(RewardTypeSummaryFromJSON)),
        'endDate': (new Date(json['endDate'])),
        'startDate': (new Date(json['startDate'])),
        'status': RewardScheduleStatusFromJSON(json['status']),
        's2wGameId': json['s2wGameId'],
        'name': json['name'],
        'id': json['id'],
        'game': S2WGameFromJSON(json['game']),
    };
}

export function RewardScheduleWithGameToJSON(value?: RewardScheduleWithGame | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rulesLink': value['rulesLink'],
        'supportLink': value['supportLink'],
        'promoText': value['promoText'],
        'rewards': ((value['rewards'] as Array<any>).map(RewardTypeSummaryToJSON)),
        'endDate': ((value['endDate']).toISOString()),
        'startDate': ((value['startDate']).toISOString()),
        'status': RewardScheduleStatusToJSON(value['status']),
        's2wGameId': value['s2wGameId'],
        'name': value['name'],
        'id': value['id'],
        'game': S2WGameToJSON(value['game']),
    };
}

